<template>
  <div>
    <header>
      <Header />
      <BreadcrumbList />
    </header>
    <div>
      <div id="main">
        <section class="updateInfo">
          <div class="updateInfoTitle">
            <div class="inner4">
              <h1>アップデート情報</h1>
              <p class="titleSub">Update Information</p>
            </div><!-- /inner4-->
          </div><!-- /updateInfoTitle-->

          <div class="updateInfoBody">

            <section v-if="isClose()" class="updateBlock">
              <div class="inner2">
                <h2>2020年11月1日：「東京カメラ部2020写真展 Online Exhibition」閉幕いたしました。</h2>
                <div class="updateBlockInner">
                  <p class="updateMessage">「東京カメラ部2020写真展 Online Exhibition」へ多くのアクセスをいただき、誠にありがとうございました。本写真展は2020年10月31日をもって終了しました。<br>
                  <span>写真展終了に伴い「応援メッセージ・感想」へのコメント受付は終了となります</span>。
                  今までに皆様から寄せられたコメントや、展示作品、ポートフォリオについては引き続き閲覧可能です。オンライントークショーについてもアーカイブ動画やレポートページを用意していますので、引き続き本サイトをお楽しみください。
                  </p>
                </div>
              </div><!-- /inner2-->
            </section><!-- /updateBlock-->

            <section class="updateBlock">
              <div class="inner2">
                <h2>2020年10月12日：サイトアップデート（ver1.2）を行いました。</h2>
                <h3>1）オンライントークショーの表示形式の変更</h3>
                <div class="updateBlockInner">
                  <p><router-link to="/talkshows">オンライントークショーのスケジュールページとアーカイブページを統合</router-link>しました。</p>
                  <ul>
                    <li>ライブ配信中のトークショーには「ON AIR」マークと配信ページへのリンクボタンを表示</li>
                    <li>配信終了したトークショーには「配信終了」マークとライブ配信のアーカイブ動画（YouTube）へのリンクボタンを表示</li>
                    <li>トークショーレポートがある場合はトークショーレポートへのリンクボタンを表示</li>
                  </ul>
                </div>

                <h3>2）応援メッセージ・感想の機能変更</h3>
                <div class="updateBlockInner">
                  <p>応援メッセージ・感想のコメント入力機能に入力内容の確認画面を追加しました。</p>
                  <p>応援メッセージ・感想のコメント入力機能のデザインを変更しました。</p>
                </div>

                <h3>3）日本写真100景フォトスポットサイトの紹介を追加</h3>
                <div class="updateBlockInner">
                  <p>日本写真100景フォトスポットサイトの紹介文とリンクボタンを追加しました。</p>
                  <ul>
                    <li><router-link to="/">トップページ</router-link>の作品展示「日本写真100景」メニュー箇所</li>
                    <li><router-link to="/artworks/Japan100Views">作品展示「日本写真100景」トップページ</router-link>の最下部。</li>
                  </ul>
                </div>

                <h3>4）アップデート情報の掲載</h3>
                <div class="updateBlockInner">
                  <p>サイトの機能やページなどの追加・更新情報を掲載する「アップデート情報」ページ（このページ）を新たに追加しました。</p>
                </div>

                <h3>5）トップページお知らせエリアの追加</h3>
                <div class="updateBlockInner">
                  <p><router-link to="/">トップページ</router-link>にサイトからのお知らせを表示するエリアを新たに追加しました。</p>
                </div>

                <h3>6）スマートフォン用メインメニューボタン位置の変更</h3>
                <div class="updateBlockInner">
                  <p>スマートフォンでの閲覧時に表示されるメインメニューボタン位置を左側に変更しました。</p>
                </div>

              </div><!-- /inner2-->
            </section><!-- /updateBlock-->

            <section class="updateBlock last">
              <div class="inner2">

                <h2>2020年9月29日：サイトアップデート（ver1.1）を行いました。</h2>

                <h3>1）ヘッダメニューの変更</h3>
                <div class="updateBlockInner">
                  <h4>名称の変更</h4>
                  <p>以下の名称を変更いたしました。</p>
                  <ul>
                    <li>「オンライン作品展示」を「作品展示」に変更</li>
                    <li>「オンライン特別展示」を「特別展示」に変更</li>
                  </ul>

                  <h4>作品展示の階層化</h4>
                  <p>東京カメラ部10選、日本写真100景、"My Precious" Photo Contestにサブメニューを用意しました。</p>
                  <ul>
                    <li>東京カメラ部10選：年度別のサブメニュー</li>
                    <li>日本写真100景：エリア別のサブメニュー</li>
                    <li>"My Precious" Photo Contest：部門別のサブメニュー</li>
                  </ul>
                  <p class="attentionUl">サブメニューをクリックで該当の箇所の最初の展示者ページへ移動します。</p>
                  <h4>スマートフォン向けメニューの変更</h4>
                  <p>上記の修正に合わせて、スマートフォンメニューも変更いたしました。</p>
                </div>

                <h3>2）作品展示 トップページの変更</h3>
                <div class="updateBlockInner">
                  <p><router-link to="/artworks">東京カメラ部10選、日本写真100景、"My Precious" Photo
                      Contestのサブメニューを表示したトップページ</router-link>に変更いたしました。</p>
                  <p class="attention">※旧トップページは「<router-link to="/exhibitors">展示者一覧</router-link>」として別途設置</p>
                </div>

                <h3>3）作品展示 カテゴリー別トップページの追加</h3>
                <div class="updateBlockInner">
                  <p><router-link to="/artworks/Tcc10Sen">東京カメラ部10選</router-link>、<router-link to="/artworks/Japan100Views">日本写真100景</router-link>、<router-link to="/artworks/MyPrecious">"My Precious" Photo Contest</router-link>
                      それぞれにカテゴリートップページを新たに追加いたしました。</p>
                  <ul>
                    <li>各トップページでは、作品サムネイル画像と展示者名を掲載しています。</li>
                    <li>サムネイルまたは展示者名をクリックで各人の展示ページへ移動します。</li>
                  </ul>
                  <p class="attentionUl">※日本100景のみは都道府県名も掲載。</p>
                </div>

                <h3>4）作品展示ページのスワイプ機能の変更</h3>
                <div class="updateBlockInner">
                  <p>東京カメラ部10選、日本写真100景、"My Precious" Photo Contest内でループするように変更いたしました。</p>
                </div>

              </div><!-- /inner2-->
            </section><!-- /updateBlock-->
          </div><!-- /updateInfoBody-->
        </section><!-- /updateInfo-->
      </div><!-- /main-->
    </div>
    <Footer />
    <UpButton />
    <QuestionnaireButton />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import BreadcrumbList from '@/components/modules/BreadcrumbList.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'
import QuestionnaireButton from '@/components/modules/QuestionnaireButton.vue'
import moment from 'moment-timezone'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    BreadcrumbList,
    UpButton,
    QuestionnaireButton
  },
  data () {
    return {
      timerId: null,
      nowDateTime: null
    }
  },
  computed: {
    ...mapGetters(['winners', 'winnersByAwardType', 'areas'])
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    },
    // 現在時刻のセット
    setNow () {
      this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      this.timerId = setInterval(function () {
        this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      }.bind(this), 1000)
    },
    isClose () {
      return true
      // return (this.nowDateTime > '20201031 23:59:59')
    }
  },
  created () {
    this.setNow()
  },
  beforeDestroy () {
    clearInterval(this.timerId)
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
</style>
